import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const authApi = {
  me: () => api.get("/auth/me").then((r) => r.data),
  session: (sessionId, referralCode) =>
    api.post("/auth/session", null, {
      headers: {
        "X-Session-ID": sessionId,
        ...(referralCode ? { "X-Referral-Code": referralCode } : {}),
      },
    }).then((r) => r.data),
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
  verify: (token) => api.post(`/auth/verify?token=${encodeURIComponent(token)}`).then((r) => r.data),
  forgot: (email) => api.post("/auth/forgot-password", { email }).then((r) => r.data),
  reset: (token, password) => api.post("/auth/reset-password", { token, password }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
};

export const marketApi = {
  quote: (s) => api.get(`/market/quote/${s}`).then((r) => r.data),
  intraday: (s) => api.get(`/market/intraday/${s}`).then((r) => r.data),
  watchlist: () => api.get(`/market/watchlist`).then((r) => r.data),
  addSymbol: (symbol) => api.post(`/market/watchlist`, { symbol }).then((r) => r.data),
  removeSymbol: (s) => api.delete(`/market/watchlist/${s}`).then((r) => r.data),
};

export const aiApi = {
  signal: (s) => api.get(`/ai/signal/${s}`).then((r) => r.data),
};

export const portfolioApi = {
  get: () => api.get("/portfolio").then((r) => r.data),
  trade: (payload) => api.post("/trades", payload).then((r) => r.data),
  trades: () => api.get("/trades").then((r) => r.data),
  csvUrl: () => `${API}/trades/export.csv`,
};

export const analyticsApi = {
  summary: () => api.get("/analytics/summary").then((r) => r.data),
};

export const settingsApi = {
  get: () => api.get("/settings").then((r) => r.data),
  update: (s) => api.put("/settings", s).then((r) => r.data),
  toggleBot: () => api.post("/bot/toggle").then((r) => r.data),
  scan: () => api.post("/bot/scan").then((r) => r.data),
};

export const alpacaApi = {
  status: () => api.get("/alpaca/status").then((r) => r.data),
  connect: (payload) => api.post("/alpaca/connect", payload).then((r) => r.data),
  disconnect: () => api.delete("/alpaca/disconnect").then((r) => r.data),
  order: (payload) => api.post("/alpaca/orders", payload).then((r) => r.data),
};

export const feesApi = {
  summary: () => api.get("/fees/summary").then((r) => r.data),
  checkout: () => api.post("/fees/checkout", { origin_url: window.location.origin }).then((r) => r.data),
  paymentStatus: (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data),
  setAutopay: (enabled) => api.post("/fees/autopay", { enabled }).then((r) => r.data),
  runAutopay: () => api.post("/fees/autopay/run").then((r) => r.data),
  statementUrl: (month) => `${API}/fees/statement.pdf${month ? `?month=${month}` : ""}`,
};

export const referralsApi = {
  status: () => api.get("/referrals/status").then((r) => r.data),
  leaderboard: (limit = 10) => api.get(`/referrals/leaderboard?limit=${limit}`).then((r) => r.data),
  publicLeaderboard: (limit = 5) => api.get(`/referrals/leaderboard?limit=${limit}&public=1`).then((r) => r.data),
};

export const botApi = {
  health: () => api.get("/bot/health").then((r) => r.data),
};

export const adminApi = {
  status: () => api.get("/admin/status").then((r) => r.data),
  setLiveTrading: (enabled) => api.post("/admin/live-trading", { enabled }).then((r) => r.data),
  contactSubmissions: (limit = 100) => api.get(`/admin/contact-submissions?limit=${limit}`).then((r) => r.data),
};

export const chatApi = {
  send: (message, session_id, guest_name) =>
    api.post("/chat/message", { message, session_id, guest_name }).then((r) => r.data),
  history: (session_id) =>
    api.get(`/chat/history${session_id ? `?session_id=${encodeURIComponent(session_id)}` : ""}`).then((r) => r.data),
  reset: (session_id) =>
    api.post(`/chat/reset${session_id ? `?session_id=${encodeURIComponent(session_id)}` : ""}`).then((r) => r.data),
};

export const contactApi = {
  submit: (payload) => api.post("/contact", payload).then((r) => r.data),
};

export const trainingApi = {
  list: () => api.get("/training/resources").then((r) => r.data),
  downloadUrl: (id) => `${API}/training/download/${id}`,
};

